export default {
  footer: {
    // leftTitle: "扫一扫，关注因美优品",
    companyAddress: "上海钰狮科技有限公司",
    Alladdress: "上海市奉贤区立新路281-289号(单)1层 ",
    icp: "沪ICP备2022005161号-1",
    security: '35018202000223',
    // scanCode1: '因美优品视频号',
    // scanCode2: '因美优品抖音号',
    // scanCode3: '因美优品公众号',
    // scanCode4: '因美优品小程序',
    // scanCode5: '视频号',
    // scanCode6: '抖音号',
    // scanCode7: '公众号',
    // scanCode8: '小程序',
  }


}
